import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub_scroll_wrap" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "scroll_nav" }

import { computed } from "vue";
import { useStore } from "vuex";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const { isLoggedIn } = useAuth();

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            style: {"width":"20% !important"},
            class: _normalizeClass({
              on: _ctx.$route.path.includes(
                _unref(USER_ROUTES).Product.Activity.Talent.Path
              ),
            })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`,
              alt: "재능진로전공직업 탐색 프로젝트"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("재능진로전공직업 탐색 프로젝트 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("li", {
            style: {"width":"20% !important"},
            class: _normalizeClass({
              on: _ctx.$route.path.includes(
                _unref(USER_ROUTES).Product.Activity.Startup.Path
              ),
            })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Activity.Startup.Path}`,
              alt: "꿈 창업 프로젝트"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("꿈 창업 프로젝트 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("li", {
            style: {"width":"20% !important"},
            class: _normalizeClass({
              on: _ctx.$route.path.includes(
                _unref(USER_ROUTES).Product.Activity.Career.Path
              ),
            })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Activity.Career.Path}`,
              alt: "데이터 사이언스 체험 활동"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("데이터 사이언스 체험 활동 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("li", {
            style: {"width":"20% !important"},
            class: _normalizeClass({
              on: _ctx.$route.path.includes(
                _unref(USER_ROUTES).Product.Activity.Growth.Path
              ),
            })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Activity.Growth.Path}`,
              alt: "성장–폴리오 과정"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("성장–폴리오 과정 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "prev" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "next" }, null, -1))
    ])
  ]))
}
}

})